import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import { Trans, withTranslation } from 'react-i18next';
import * as alert from '../../../../common/services/alert';
import { Button } from '../../../../common/components/button';
import * as Form from '../../../../common/components/form';
import updateNetwork from '../../actions/update-network';
import validate from '../validators/network';

const { Row, Group, Label, TextInput } = Form;

class NetworkForm extends PureComponent {
  static propTypes = {
    network: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
  };

  static defaultProps = {
    network: {},
  };

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, dispatch) {
    try {
      await dispatch(updateNetwork(values));

      alert.success(this.props.t('network:forms_network_success'));
    } catch (response) {
      alert.forStatus(response.status_code, {
        warning: this.props.t('network:forms_network_warning'),
        error: this.props.t('network:forms_network_error'),
      });
    }
  }

  render() {
    const { handleSubmit, submitting, invalid, t } = this.props;

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)} className="Form Form--horizontal">
        <Row>
          <Group>
            <Label text={t('network:forms_network_name')} />
            <TextInput name="name" />
          </Group>
        </Row>
        <hr />
        <Row>
          <Button
            buttonType="submit"
            type="primary"
            isLoading={submitting}
            disabled={invalid}
          >
            <Trans i18nKey="network:forms_network_submit" />
          </Button>
        </Row>
      </form>
    );
  }
}

export default withTranslation()(reduxForm({
  form: 'network',
  initialValues: { name: '' },
  validate,
})(NetworkForm));
